import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class NationalityService {

  constructor(private  httpClient: HttpClient) {
  }

  getNationalities() {
    return this.httpClient.get('/systemconfig/nationality/');
  }

  /////////old//////////////
  getNationality(id) {
    return this.httpClient.get(`/systemconfig/nationality/${id}/`);
  }

  getNationalitie(id){
    return this.httpClient.get('/systemconfig/nationalities/', {params : {id:id}})
    }

  postNationality(nationality) {
    return this.httpClient.post('/systemconfig/nationality/', nationality);
  }

  ///////////old///////////////
  updateNationality(id, nationality) {
    return this.httpClient.patch(`/systemconfig/nationality/${id}/`, nationality);
  }

  updateNationalities(nationality){
    return this.httpClient.post('/systemconfig/nationalities/',nationality)
  }
}
